import React from 'react';
import StyledCustomInput from 'components/StyledCustomInput';

export default function RenderedCustomInput({
  input,
  label,
  type,
  id,
  placeholder,
  meta: { touched, error, warning, valid, pristine }
}) {
  return (
    <React.Fragment>
      <StyledCustomInput
        {...input}
        type={type}
        id={id}
        placeholder={placeholder}
        valid={(pristine && !touched) || (touched && valid)}
        label={label}
      />
      {touched &&
        ((error && <span className="text-danger">{error}</span>) ||
          (warning && <span className="text-warning">{warning}</span>))}
    </React.Fragment>
  );
}
